import Navbar from "../components/Navbar";
import { FaAngleDoubleDown } from "react-icons/fa";
import FacultyTabs from "../components/FacultyTable";
import { Helmet } from 'react-helmet-async';
// Faculty.js


const FacultyPage = () => {
  const scrollToContent = () => {
    const section = document.getElementById("session-tabs");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <Helmet>
        <title>Faculty - Art India Education</title>
      </Helmet>
      <Navbar />
      <main>
        {/* Top Half-Screen Banner Section */}
        <section className="relative h-screen w-full overflow-hidden font-['EB_Garamond','Nunito','sans-serif']">
          <div className="relative w-full h-full overflow-hidden">
            {/* 🔳 Overlay */}
            <div className="absolute inset-0 bg-black/50 z-10"></div>

            {/* 🖼️ Image */}
            <img
              src="RAQS-MEDIA-COLLECTIVE-ODEION-6737.jpg"
              alt={`banner`}
              className="absolute top-[-25%] h-[150%] w-full object-cover z-0"
            />

            {/* 📄 Text Wrapper */}
            <div className="absolute inset-0 z-20 flex flex-col justify-center items-center text-white text-center px-4">
              <h1 className="text-8xl font-extrabold mb-6">Faculty</h1>
              <p className="text-2xl font-medium max-w-2xl">
                Industry experts including noted academics, collectors, curators, art historians,
                and art practitioners with valuable experience in the field of Modern &
                Contemporary Indian art.
              </p>
            </div>
          </div>
          {/* ⬇️ Double Down Arrow */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce">
            <FaAngleDoubleDown size={32} />
          </div>
          <button
            onClick={scrollToContent}
            className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce"
            aria-label="Scroll to content"
          >
            <FaAngleDoubleDown size={32} />
          </button>

        </section>
        <section id="session-tabs" >
          <FacultyTabs />
        </section>

      </main>
    </>
  );
};
export default FacultyPage;